import { render, staticRenderFns } from "./ProfitabilityComponent.vue?vue&type=template&id=2b70d016&scoped=true&lang=pug"
import script from "./ProfitabilityComponent.vue?vue&type=script&lang=ts"
export * from "./ProfitabilityComponent.vue?vue&type=script&lang=ts"
import style0 from "./ProfitabilityComponent.vue?vue&type=style&index=0&id=2b70d016&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70d016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b70d016')) {
      api.createRecord('2b70d016', component.options)
    } else {
      api.reload('2b70d016', component.options)
    }
    module.hot.accept("./ProfitabilityComponent.vue?vue&type=template&id=2b70d016&scoped=true&lang=pug", function () {
      api.rerender('2b70d016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/Profitability/ProfitabilityComponent.vue"
export default component.exports